import styles from "./RoadmapSection.module.css";
import { Droppable, Draggable } from "react-beautiful-dnd";

// react
import React from "react";

//components
import StatusTitle from "components/StatusTitle";
import RoadmapItem from "./RoadmapItem";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

export default function RoadmapSection(props) {
	const { role } = useContext(MyContext);
	const { features, status } = props;
	return (
		<Droppable key={status} droppableId={`${status}`}>
			{(provided, snapshot) => (
				<div ref={provided.innerRef} {...provided.droppableProps}>
					<div className={styles.items}>
						<StatusTitle status={status + 2} />
						{features.map((feature, index) => {
							return (
								<Draggable
									isDragDisabled={role !== Role.Admin}
									key={feature.idFeature}
									draggableId={feature.idFeature.toString()}
									index={index}
								>
									{(provided, snapshot) => (
										<div
											ref={provided.innerRef}
											{...provided.draggableProps}
											{...provided.dragHandleProps}
										>
											<RoadmapItem
												key={feature.idFeature}
												feature={feature}
												status={feature.status}
											/>
										</div>
									)}
								</Draggable>
							);
						})}
					</div>
					{provided.placeholder}
				</div>
			)}
		</Droppable>
	);
}
